// this is an autogenerated file from App/Account/Content/Tasks/New/MigrationModal/Empty/Content/MigrateAction/Content/mutation-migrate-tasks.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_MigrationModal_Empty_Content_MigrateAction_Content{
  tasks_migrate {
    ok
  }
}

`